import { render } from "./BasicUsage.vue?vue&type=template&id=612aa7c8"
import script from "./BasicUsage.vue?vue&type=script&lang=ts"
export * from "./BasicUsage.vue?vue&type=script&lang=ts"
script.render = render

export default script